module.exports = __webpack_public_path__ + "static/coupon-b61f2d7e02d62b44633d5175effd17c8.jpg";